/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EAssociatedCompanyStatus } from "../types/EAssociatedCompanyStatus.ts";

/**
 * @description 1 = Associated | 2 = InProcess | 3 = NotAssociated |
 */
export const eAssociatedCompanyStatusSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3)])
  .describe(
    "1 = Associated | 2 = InProcess | 3 = NotAssociated | ",
  ) as unknown as ToZod<EAssociatedCompanyStatus>;
